// megaMenuData.js
export const megaMenuUpdatedContent = {
    menuServices: {
        mainNavHeading: "Services",
        aiPagesList: {
            shortHeading: "AI Innovation for Every Need",
            mainHeading: "AI Services",
            aiList: [
                {
                    text: "AI ML Services",
                    subText:
                        "Harness the power of AI & Machine Learning to automate workflows, drive smarter decisions, & accelerate growth.",
                    link: "/ai-ml-development-services",
                },
                {
                    text: "AI Chatbot Development",
                    subText:
                        "Use AI chatbots to automate conversations, boost engagement, & drive growth.",
                    link: "/ai-chatbot-development-services",
                },
                {
                    text: "AI Automation Services",
                    subText:
                        "Automate workflows, improve efficiency, & accelerate business growth with AI.",
                    link: "/ai-automation-agency",
                },
                {
                    text: "AI Agent Development",
                    subText:
                        "Automate your business processes & get a competitive edge with intelligent AI agents.",
                    link: "/ai-agent-development-services",
                },
                {
                    text: "Computer Vision Development",
                    subText:
                        "Automate your business processes & get a competitive edge with intelligent AI agents.",
                    link: "/computer-vision-development-services",
                },
                {
                    text: "Generative AI Development",
                    subText:
                        "Leverage generative AI to create smarter solutions, streamline workflows, & drive innovation with customized AI-powered systems.",
                    link: "/generative-ai-development-services",
                },
            ]
        },

        technologies: {
            mainHeading: "Emerging Technologies",
            pageList: [
                {
                    text: "AI ML Services",
                    subText:
                        "Harness the power of AI & Machine Learning to automate workflows, drive smarter decisions, & accelerate growth.",
                    link: "/ai-ml-development-services",
                },
                {
                    text: "AI Chatbot Development",
                    subText:
                        "Use AI chatbots to automate conversations, boost engagement, & drive growth.",
                    link: "/ai-chatbot-development-services",
                },
                {
                    text: "Ecommerce Solutions",
                    subText: "Automate workflows, improve efficiency, & accelerate business growth with AI.",
                    link: "/ecommerce-services"
                },
                {
                    text: "Blockchain Development",
                    subText:
                        "Building secure & transparent decentralized solutions to revolutionize industries.",
                    link: "/blockchain-development-services",
                },
                {
                    text: "AI Automation Services",
                    subText:
                        "Automate workflows, improve efficiency, & accelerate business growth with AI.",
                    link: "/ai-automation-agency",
                },
            ]
        },

        softwareDevelopment: {
            mainHeading: "Software Development",
            pageList: [
                {
                    text: "Web Application Development",
                    subText:
                        "Crafting robust, scalable web applications to elevate your business online.",
                    link: "/web-app-development-services",
                },

                {
                    text: "Custom Development",
                    subText:
                        "Tailored software solutions designed to meet your unique business needs.",
                    link: "/custom-software-development-services",
                },
                {
                    text: "Mobile App Development",
                    subText:
                        "Creating intuitive mobile experiences that engage users & drive business growth.",
                    link: "/mobile-app-development-services",
                },
                // {
                //     text: "Data Analytics",
                //     subText:
                //         "Transforming data into actionable insights to drive informed decision-making & growth.",
                //     link: "/data-analytics-services",
                // },
                {
                    text: "DevOps Services",
                    subText:
                        "Streamlining development & operations for faster delivery & enhanced collaboration.",
                    link: "/dev-ops-services",
                },
                // {
                //     text: "Quality Assurance Services",
                //     subText:
                //         "Ensuring top-notch quality through rigorous testing & validation for flawless performance.",
                //     link: "/quality-assurance-services",
                // },
            ]
        },

        engagementModels: {
            mainHeading: "Engagement Models",
            pageList: [
                // {
                //     text: "Build-Operate-Transfer (BOT)",
                //     link: "/engagment-model"
                // },
                {
                    text: "Flexible Teams",
                    link: "/engagment-model"
                },
                {
                    text: "Dedicated Teams",
                    link: "/engagment-model"
                },
                {
                    text: "Turnkey Project Solutions",
                    link: "/engagment-model"
                },
                // {
                //     text: "Turnkey Price Projects",
                //     link: "/engagment-model"
                // },
                // {
                //     text: "White-Label Partnership",
                //     link: "/engagment-model"
                // },
            ]
        },

        MenuIndustries: {
            mainHeading: "Industries",
            pageList: [
                {
                    text: "Healthcare",
                    link: "/healthcare"
                },
                {
                    text: "E-commerce & Retail",
                    link: "/retail-ecommerce"
                },
                {
                    text: "Real Estate",
                    link: "/real-estate"
                },
                {
                    text: "Automotive & Logistics",
                    link: "/automotive-logistics"
                },
                {
                    text: "Ed-Tech",
                    link: "/education"
                },
                {
                    text: "Gaming & Entertainment",
                    link: "/gaming-entertainment"
                },
                // {
                //     text: "Social Networking",
                //     link: "/social-networking"
                // },
                // {
                //     text: "Telecom",
                //     link: "/telecom"
                // },
                // {
                //     text: "Energy",
                //     link: "/energy"
                // },
                // {
                //     text: "Agriculture",
                //     link: "/agriculture"
                // },
            ]
        },

        menuSolution: {
            mainHeading: "Solutions",
            pageList: [
                {
                    text: "Aura Clinic",
                    link: "/solutions/auraclinic",
                    target: "self"
                },
                {
                    text: "Supply Chain Management",
                    link: "#"
                },
                {
                    text: "E-commerce",
                    link: "#"
                },
                {
                    text: "Real estate management & Analytics",
                    link: "#"
                },
                {
                    text: "Digital Currency Portfolio & Analytics",
                    link: "#"
                },
                {
                    text: "Multi Branch & Avanders",
                    link: "#"
                },
            ]
        }
    },

    menuEngeniers: {
        mainNavHeading: "Engineers",
        aiEngeniersList: {
            mainHeading: "AI & Data Engineers",
            pageList: [
                {
                    text: "Hire Machine Learning Engineers",
                    subText: "",
                    link: "/hire-machine-learning-engineers",
                },
                {
                    text: "Hire Data Scientists Engineers",
                    subText: "",
                    link: "/hire-data-scientists-engineers",
                },
                // {
                //     text: "AI Services",
                //     subText:
                //         "Harness the power of AI & Machine Learning to automate workflows, drive smarter decisions, & accelerate growth.",
                //     link: "/ai-ml-development-services",
                // },
            ]
        },

        mernEngeniersList: {
            mainHeading: "Full Stack & DevOps Engineers",
            pageList: [
                // {
                //     text: "Hire Mern Stack",
                //     subText:
                //         "Skilled MERN Stack developers ready to build full-stack applications with MongoDB, Express.js, React, & Node.js for optimal performance.",
                //     link: "/hire-mern-stack-developer",
                // },
                {
                    text: "Hire Python Developers",
                    subText:
                        "Talented Python developers available to deliver versatile & efficient solutions for your projects.",
                    link: "/hire-python-developers",
                },
                {
                    text: "Hire DevOps Developers",
                    subText: "",
                    link: "/hire-devops-engineers",
                },
                {
                    text: "Hire React Js Developers",
                    subText:
                        "Skilled React developers available to craft responsive & high-performing user interfaces for your applications.",
                    link: "/hire-react-js-developers",
                },
                // {
                //     text: "Hire JavaScript",
                //     subText:
                //         "Experienced JavaScript developers to create dynamic & interactive web applications tailored to your vision.",
                //     link: "/hire-javascript-developer",
                // },
                // {
                //     text: "Hire Node",
                //     subText:
                //         "Experienced Node.js developers to create scalable & efficient server-side applications that power your business.",
                //     link: "/hire-node-js-developer",
                // },
                // {
                //     text: "Hire Angular",
                //     subText:
                //         "Proficient Angular developers dedicated to building dynamic, high-performance web applications with a seamless user experience.",
                //     link: "/hire-angular-developer",
                // },
            ]
        },

        mobileEngeniersList: {
            mainHeading: "Mobile App Engineers",
            pageList: [
                // {
                //     text: "Hire Mobile AI & ML Engineers",
                //     subText: "",
                //     link: "/hire-mobile-ai-ml-engineers"
                // },
                {
                    text: "Hire Flutter Developers",
                    subText:
                        "Expert Flutter developers ready to build beautiful, natively compiled applications for mobile, web, & desktop from a single codebase.",
                    link: "/hire-flutter-developers",
                },
                {
                    text: "Hire React Native Developers",
                    subText: "",
                    link: "/hire-react-native-developers",
                },
                {
                    text: "Hire Android Developers",
                    subText:
                        "Experienced android developers to create intuitive & robust mobile applications tailored for android users.",
                    link: "/hire-android-developers",
                },
            ]
        },

        webApplicationsEngeniersList: {
            mainHeading: "Web Applications",
            pageList: [
                {
                    text: "Hire Ruby Rails",
                    subText:
                        "Expert Ruby on Rails developers ready to build scalable & efficient web applications for your business.",
                    link: "/hire-ruby-on-rails-developer",
                },
                {
                    text: "Hire Django",
                    subText:
                        "Skilled Django developers to create powerful, high-performance web applications tailored to your needs.",
                    link: "/hire-django-developer",
                },
                // {
                //     text: "Hire Python developers",
                //     subText:
                //         "Talented Python developers available to deliver versatile & efficient solutions for your projects.",
                //     link: "/hire-python-developers",
                // },
                {
                    text: "Hire Go Lang",
                    subText:
                        "Proficient Go developers ready to build high-performance applications with efficiency & speed.",
                    link: "/hire-golang-developer",
                },
            ]
        },
    },

    menuBarBox: {
        // mainHeading: "Company insights & Services",
        pageList: [
            // {
            //     text: "Industries",
            //     link: "/Industries",
            // },
            {
                text: "About Us",
                link: "/about-us",
            },
            // {
            //     text: "Case Studies",
            //     link: "/case-studies",
            // },
            {
                text: "Blogs & Insights",
                link: "/blogs",
            },
            // {
            //     text: "Engagement Models",
            //     link: "/engagment-model",
            // },
            {
                text: "Contact Us",
                link: "/contact-us",
            },
        ],
    },

    caseStudiesHeading: "Case Studies",
    // EngagementModelsHeading: "Engagement Models"
    // mainNav: [
    //     {
    //         text: "Home",
    //     },
    //     {
    //         text: "Company",
    //     },
    //     {
    //         text: "What We Do",
    //     },
    //     {
    //         text: "Portfolio",
    //     },
    //     {
    //         text: "Hire Experts",
    //     },
    //     {
    //         text: "Let's Connect",
    //     },
    //     {
    //         text: "Case Studies",
    //     },
    // ],
};